export default "__VITE_ASSET__BeWqJhs1__"